import type { IconProps } from '../types';

export function EmailIcon({ className, title }: IconProps) {
  return (
    <svg
      viewBox="0 0 26 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <path
        d="M1 5.16675L11.5208 12.1806C12.4165 12.7778 13.5835 12.7778 14.4792 12.1806L25 5.16675M3.66667 19.8334H22.3333C23.8061 19.8334 25 18.6395 25 17.1667V3.83341C25 2.36066 23.8061 1.16675 22.3333 1.16675H3.66667C2.19391 1.16675 1 2.36066 1 3.83341V17.1667C1 18.6395 2.19391 19.8334 3.66667 19.8334Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
